module.exports = __webpack_public_path__ + "static/project-16e-0afe5a225b4e3ab550af22354e7264e0.png";